module.exports = __webpack_public_path__ + "static/media/map.ec2cf49f.png";